let expanded = false;

const container = $(".collection--short-description");

const paragraph = $(container).find(".metafield-rich_text_field");
const text = $(paragraph).find("p");

// get the height of both paragraph and text
const paragraphHeight = paragraph[0].scrollHeight;
const textHeight = text[0].scrollHeight;

// if the text is taller than the paragraph, show the read more button
if (textHeight > paragraphHeight) {
    $(container).addClass("has-read-more");
}

$("#read-more").click((e) => {
    e.preventDefault();
    $(".collection--short-description").toggleClass("is-expanded");

    if (!expanded) {
        e.target.innerHTML = "Lees minder";
    } else {
        e.target.innerHTML = "Lees meer";
    }

    expanded = !expanded;
});
